import appApi from '../../../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalSettingsStores from '../../../../../../../stores/settings-stores';

export const createNewClassOperations = async (
  branchId: number | undefined,
  buildingId: number | undefined,
  className: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (!buildingId || !branchId) {
      //toast.warn(`לא ניתן לאתר את הבמנה המבוקש, נסה שוב בעוד מספר רגעים`);
      throw new Error('BranchId ot Building is not define');
    }

    setLoading(true);
    const newClassRes = await appApi.addClass(buildingId, className);
    globalSettingsStores.fetchSetting();
    setLoading(false);
    closeDialog();
  } catch (e) {
    setLoading(false);
    toast.error(`יצירת הכיתה ${className} נכשלה, נסה שוב מאוחר יותר`);
    console.error(`createNewClassOperations is failed with the error: ${e}`);
  }
};
